import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { api } from '../api.js';

const DEFAULT_TEXT = `TÉRMINOS DE SERVICIO

Última actualización: 21 de febrero de 2026

1. Objeto del servicio
La plataforma permite crear plantillas, ejecutar renders (sync/async), administrar activos, scripts, usuarios y planes de facturación por usuario.

2. Aceptación
Al usar la plataforma usted acepta estos términos, la Política de Privacidad y el Aviso Legal.

3. Cuenta y seguridad
Cada usuario es responsable del resguardo de credenciales y de la actividad realizada con su sesión.

4. Planes y límites
El uso está sujeto al plan asignado y sus límites (renders, concurrencia, plantillas activas, API por minuto y funciones habilitadas).

5. Uso permitido
Queda prohibido el uso ilícito, la evasión de controles técnicos, la intrusión o el abuso de infraestructura.

6. Jurisdicción
Se aplican las leyes de los Estados Unidos Mexicanos y la jurisdicción competente en México.`;

export default function TermsOfServicePage() {
  const [content, setContent] = useState(DEFAULT_TEXT);
  const [updatedAt, setUpdatedAt] = useState('21 de febrero de 2026');

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const data = await api.getPublicLegalContent();
        if (!mounted) return;
        setContent(data?.termsOfService || DEFAULT_TEXT);
        if (data?.updatedAt) {
          setUpdatedAt(new Date(data.updatedAt).toLocaleDateString('es-MX', { year: 'numeric', month: 'long', day: 'numeric' }));
        }
      } catch {
        if (mounted) setContent(DEFAULT_TEXT);
      }
    })();

    return () => {
      mounted = false;
    };
  }, []);

  return (
    <div className="legal-page">
      <div className="legal-page__container">
        <div className="legal-page__top">
          <Link className="legal-page__back" to="/">← Volver al inicio</Link>
          <p className="legal-page__updated">Última actualización: {updatedAt}</p>
        </div>

        <h1>Términos de Servicio</h1>
        <div className="legal-page__text">{content}</div>
      </div>
    </div>
  );
}
